import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";

/**
 * Reporting / denormalized ticket fields
 * Populated by database triggers for display and filtering without joins.
 * These fields are read-only and excluded from API submissions.
 *
 * No `savedViewMembership` — not in default saved views.
 */
export const reportingFields = defineFieldConfigMap({
  // FIELD: company_name
  company_name: {
    type: "text",
    label: "Company Name",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false,
    excludeFromApi: true,
    filterType: "contains",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    icon: "Building2",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "reporting",
    graphqlSelector: "company_name",
  },

  // FIELD: contact_name
  contact_name: {
    type: "text",
    label: "Contact Name",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false,
    excludeFromApi: true,
    filterType: "contains",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    icon: "User",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "reporting",
    graphqlSelector: "contact_name",
  },

  // FIELD: is_software
  is_software: {
    type: "boolean",
    label: "Software",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false,
    excludeFromApi: true,
    filterType: "exact",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Monitor",
    groupable: true,
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "reporting",
    graphqlSelector: "is_software",
  },
});
